import { useParams } from 'react-router-dom';
import { Card, Divider, Spin, Typography } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import RoomWantedForm from '../components/RoomWantedForm';
import AdImageManager from '@/features/room-ads/components/AdImageManager';
import { useRoomWantedDetails } from '../hooks/useRoomWantedDetails';
import { useUpdateRoomWanted } from '../hooks/useRoomWantedMutations';

export default function RoomWantedEditPage() {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data, isLoading: loadingDetails, refetch } = useRoomWantedDetails(id);
  const mutation = useUpdateRoomWanted();

  const handleSubmit = (formData: any) => {
    (mutation.mutate as any)({ id, data: formData });
  };

  if (loadingDetails) return <Spin style={{ display: 'block', margin: '80px auto' }} />;

  return (
    <div>
      <PageHeader back title={t('roomWanted.editTitle')} subtitle={`#${id}: ${data?.title || ''}`} />
      <Card>
        <RoomWantedForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
      <Card style={{ marginTop: 16 }}>
        <Typography.Title level={5} style={{ marginTop: 0 }}>{t('roomWanted.images')}</Typography.Title>
        <Divider style={{ margin: '8px 0 16px' }} />
        {id && <AdImageManager adId={id} resource="room-wanted" onChange={() => refetch()} />}
      </Card>
    </div>
  );
}
